import { render } from "./batch-row.vue?vue&type=template&id=45d4370a&lang=pug"
import script from "./batch-row.vue?vue&type=script&lang=js"
export * from "./batch-row.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__